import axios from "./axios";

const EmailLogs = {
  /**
   * Fetches email logs with pagination and filters
   *
   * @param {object} params - Query parameters
   * @param {number} params.page - Page number (default: 1)
   * @param {number} params.limit - Items per page (default: 20)
   * @param {string} params.category - Filter by category
   * @param {string} params.status - Filter by status (SENT/FAILED)
   * @param {string} params.startDate - Filter start date
   * @param {string} params.endDate - Filter end date
   * @param {string} params.search - Search in recipient/subject
   * @return {object} Paginated email logs
   */
  async getLogs(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);
      if (params.category) queryParams.append("category", params.category);
      if (params.status) queryParams.append("status", params.status);
      if (params.startDate) queryParams.append("startDate", params.startDate);
      if (params.endDate) queryParams.append("endDate", params.endDate);
      if (params.search) queryParams.append("search", params.search);

      const res = await axios.get(`/emails/logs?${queryParams.toString()}`);
      return { ok: true, data: res.data };
    } catch (error) {
      return { ok: false, data: { content: [], total: 0 } };
    }
  },

  /**
   * Fetches email statistics by category
   *
   * @return {object} Statistics object
   */
  async getStats() {
    try {
      const res = await axios.get("/emails/logs/stats");
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {
          total: 0,
          totalSent: 0,
          totalFailed: 0,
          recentActivity: 0,
          byCategory: [],
        },
      };
    }
  },

  /**
   * Fetches all emails sent to a specific user
   *
   * @param {string} userId - User ID
   * @return {array} Array of email logs
   */
  async getByUser(userId) {
    try {
      const res = await axios.get(`/emails/logs/user/${userId}`);
      return { ok: true, data: res.data };
    } catch (error) {
      return { ok: false, data: [] };
    }
  },

  /**
   * Fetches a single email log by ID
   *
   * @param {string} id - Email log ID
   * @return {object} Email log details
   */
  async getById(id) {
    try {
      const res = await axios.get(`/emails/logs/${id}`);
      return { ok: true, data: res.data };
    } catch (error) {
      return { ok: false, data: null };
    }
  },
};

export default EmailLogs;
